import { Api } from '@sodamnfoolish/sjc-backend-types';
import { useBackend } from './UseBackend';
import { useBonkGateway } from './useBonkGateway';
import { CommonUseBubblesProps, useBubbles } from './useBubbles';

export function useBonkBubbles(props: CommonUseBubblesProps) {
    // TODO: useBackend not neccessary to be a hook, probably can be single instance
    const { getBonkBubbles } = useBackend();

    const { bonkGatewayClient } = useBonkGateway();

    return useBubbles<Api.Bonk.DTO.LetsBonkBubble, Api.Bonk.DTO.LetsBonkBubbleUpdate>({
        ...props,
        getBubbles: getBonkBubbles,
        client: bonkGatewayClient,
        updateEventName: Api.Bonk.Gateway.Event.BubbleUpdate,
    });
}
